<template>
    <div :id="'national_service--' + element.id"
         class="item pb-3 mb-5 border-bottom">
        <div class="row">
            <div class="col-12 col-lg-4 mb-3 text-center position-relative">
                <badge class="position-absolute selected-badge" v-if="element.isSelected"></badge>
                <img :src="logoPath"
                     alt="" class="mw-100 position-relative image">
            </div>

            <div class="col-12 col-lg-8">

                <!--            Name -->
                <h2 v-if="element.name" class="col-12">{{ element.name }}</h2>

                <!--            Description -->
                <div v-if="element.description"
                     class="col-12"
                     v-html="element.description"></div>

                <!--        Button Group -->
                <div class="col-12 d-flex flex-row justify-content-end">
                    <div class="btn-group mt-3"
                         role="group">
                        <!--            Button Activate -->
                        <button
                            :disabled="element.isSelected || syncingData"
                            class="btn btn-sm btn-success"
                            type="button"
                            @click="toggleService(element, 'activate')">Aktivieren <i v-if="!syncingData"
                                                                                      class="fas fa-plus"></i><i
                            v-if="syncingData" class="fas fa-spinner fa-spin"></i></button>

                        <!--            Button Deactivate -->
                        <button
                            :disabled="!element.isSelected || syncingData"
                            class="btn btn-sm btn-danger"
                            type="button"
                            @click="toggleService(element, 'deactivate')">Deaktivieren <i v-if="!syncingData"
                                                                                          class="fas fa-minus"></i><i
                            v-if="syncingData" class="fas fa-spinner fa-spin"></i></button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'Brand',
    props: {
        item: Object,
        isActive: Boolean,
    },
    data() {
        return {
            isEdit: false,
            element: this.item,
            errors: {},
            isLoading: false,
            syncingData: false,
        };
    },
    methods: {
        toggleService(payload, method) {
            this.syncingData = true;
            axios.post('/api/merchant/brands', {
                payload: payload,
                method: method,
            }).then((response) => {
                this.syncingData = false;
                this.element = response.data.element;
                this.$swal({
                    title: response.data.message,
                });
            }).catch((error) => {
                this.$swal({
                    icon: 'error',
                    title: 'Die Daten konnten nicht geladen werden',
                });
            });
        },
    },
    computed: {
        logoPath() {
            if (this.element.logo !== null) {
                return '/storage' + this.element.logo;
            }
            return '/images/placeholder.png';
        },
    },
};
</script>

<style scoped>
    .selected-badge {
        position: absolute;
        z-index: 9;
        transform: rotate(-40deg);
        left: -3px;
        font-size: 1.2rem;
    }
</style>
